import { render, staticRenderFns } from "./AbnormalDataExport.vue?vue&type=template&id=6841a7f6&scoped=true"
import script from "./AbnormalDataExport.vue?vue&type=script&lang=js"
export * from "./AbnormalDataExport.vue?vue&type=script&lang=js"
import style0 from "./AbnormalDataExport.vue?vue&type=style&index=0&id=6841a7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841a7f6",
  null
  
)

export default component.exports